import classes from './DownloadCtaCard.module.scss';
import Image from 'next/image';
import { fireEvent } from '../../../utils/netmera';

export default function DownloadCtaCard(props) {
    const { card_image, site_title, help_text, overlayState } = props;

    return (
        <div className={`${classes.oCard} ${classes[overlayState]} oDownloadCard`}>
            <figure className={classes.mCardImage}>
                <Image
                    src={card_image?.data?.attributes?.url}
                    alt={`chat`}
                    width={card_image?.data?.attributes?.width}
                    height={card_image?.data?.attributes?.height}
                    className={classes.aImage}
                    layout="responsive"
                    aria-hidden="true"
                />
            </figure>
            <div className={`${classes.mCardBody} mCardBody fontRTL`}>
                {/* <span className={`${classes.aCapsule} fnt16s`}>{card_title}</span> */}
                <h1 className={`${classes.textTitle} aTitle fnt46 fnt-sb `}>{site_title}</h1>
                <div
                    className={`${classes.ctaWrapper} aCtaWrapper`}
                    onClick={() => fireEvent('appDownloadApk')}
                >
                </div>
            </div>
            <p className={`${classes.aCardFootNote} fnt14f fontRTL`}>{help_text}</p>
        </div>
    );
}
